export default "__VITE_ASSET__9bc99dda__"